<mat-toolbar class=toolbar>

    <div fxFlex="40" fxLayoutAlign=start class=left>

        <div class=title>
            GP MANAGER
        </div>

    </div>

    <div fxLayoutAlign="center" fxFlex="20">
        <img class=logo src="assets/images/logo.png" routerLink="/home">
    </div>

    <div fxFlex="1 0 40" fxLayoutAlign="start" class=right>

        <div fxFlex="1 0 80" fxHide.lt-md fxLayoutAlign=center>

            <span style="font-size: 15px;">
				BENVENUTO <strong>{{user?.firstName || ""}} {{user?.lastName || ""}}</strong> il tuo ruolo è: <strong><u>{{this.utils.myRole}}</u></strong>
			</span>

        </div>

        <div fxFlex="1 0 20" fxFlex.lt-md=100 fxLayoutAlign=end>
            <button class="logout-button" mat-raised-button color=warn (click)="onLogout()">
				<mat-icon>logout</mat-icon>
				LOGOUT
			</button>
        </div>

    </div>

</mat-toolbar>